<template>
	<div>
		<PageHeaderLayout>
			<el-button type="" style="margin-bottom: 10px;" @click="goBack()"  icon="el-icon-back" size="medium">
				返回
			</el-button>
			<div class="main-page-content"
				v-loading="loadingStaus"
				:element-loading-text="loadingText">
                <div class="name">
                    {{formData.title}}
                </div>
				<el-row :gutter="48">
                    <el-form label-position="top" :model="formData" ref="info">
                        <!-- 注意，如果需要兼容微信小程序，最好通过setRules方法设置rules规则 -->
                        <div v-for="(item,index) in formData.topic" :key="index" class="form-content">
                            <el-form-item v-if="item.type===2" :prop="'Q_'+index" :ref="'item_'+index">
                                <template slot="label">
                                    <div class="title">
                                        Q{{index+1}}: {{item.title}}
                                    </div>
                                </template>
                                
                                <div class="form-input">
                                    <div v-for="(item_1,index_1) in item.options" :key="index_1">
                                        <div v-if="item_1.name" class="input-tite">{{item_1.name}}</div>
                                        
                                        <el-input disabled type="textarea" v-if="item.options.length<=1" v-model="item_1.answers"></el-input>
                                        <el-input disabled v-else v-model="item_1.answers"></el-input>
                                    </div>
                                </div>
                            </el-form-item>
                                
                            <el-form-item v-if="item.type===1" :prop="'Q_'+index" :ref="'item_'+index">
                                <template slot="label">
                                    <div class="title">
                                        Q{{index+1}}: {{item.title}}
                                    </div>
                                </template>
                                <el-checkbox-group disabled v-model="item.answers" @change="change">
                                    <el-checkbox :customStyle="{marginRight: '16px'}" activeColor="#0038CD"
                                        v-for="(item_1, index_1) in item.options" :key="index_1" :label="item_1.id">{{item_1.name}}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <div v-if="item.type===0">
                                <el-form-item :prop="'Q_'+index" :ref="'item_'+index">
                                    <template slot="label">
                                        <div class="title">
                                            Q{{index+1}}: {{item.title}}
                                        </div>
                                    </template>
                                    <el-radio-group disabled v-model="item.answers">
                                        <el-radio :customStyle="{marginRight: '40px'}" activeColor="#0038CD"
                                            v-for="(item_1, index_1) in item.options" :key="index_1" :label="item_1.id">
                                            {{item_1.name}}
                                        </el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </div>
                        </div>
                    </el-form>
				</el-row>
			</div>
		</PageHeaderLayout>
	</div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import UploadFile from "@/components/UploadFile";
import { mapGetters } from 'vuex'

export default {
	components: {
		PageHeaderLayout,
		UploadFile,
	},
	data() {
		return {
			dialogVisible: false,
			activeTab: '0',
			hearTitle: '基本设置',
			loadingStaus: true,
			loadingText: '正在提交中……',
			formData:{},
			// 已上传图片列表
			uploadFileList:[],
			id:this.$route.query.id
		}
	},
	computed: {
		...mapGetters(['userPermissions']),
	},
	methods: {
        change(e){
            console.log(e)
        },
		// 初始化公司基本信息
		async init() {
			if(this.id) {
				this.formData = {};
                let info = await this.$api.getQuestionnaireInfo(this.id)
                info.topic.forEach((item,index)=>{
                    if(item.type===1){
                        let answers = []
                        if(item.options.length){
                            item.options.forEach((item_1)=>{
                                if(item_1.answers===item_1.id){
                                    answers.push(item_1.id)
                                }
                            })
                            info.topic[index].answers = answers
                        }
                    }else if(item.type===0){
                        let answers = ''
                        if(item.options.length){
                            item.options.forEach((item_1)=>{
                                if(item_1.answers===item_1.id){
                                    answers=item_1.id
                                }
                            })
                            info.topic[index].answers = answers
                        }
                    }
                })
                console.log(info)
                this.formData = info
			}
		},
		//返回上一页
		goBack() {
			this.$router.push({ path: "/questionnaire"});
		}
	},
	async mounted() {
		this.loadingStaus = true
		this.init()
		this.$nextTick(() => {
			this.loadingStaus = false
		})
	},
}
</script>

<style lang="scss" scoped>
    .main-page-content{
        padding: 40px;
    }
    .name{
        font-size: 28px;
        text-align: center;
        margin-bottom: 20px;
    }
    /deep/ .el-radio{
        margin-bottom: 10px;
    }
</style>
